export const FrontUrl = 'https://footbalancetech.com';
//export const FrontUrl = 'http://localhost:3000';